<template>
  <div class="afternoon">
    <h2 class="subtitle">
      Afternoon Sessions
    </h2>
    <div v-if="isMobile" class="mobile slider">
      <carousel>
        <slide :key="1">
          <div class="grid__tracks">
            <div class="--title">
              Track 1 (Fauno West)
            </div>
            <div class="--slot t1" v-for="info in track1" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <slide :key="2">
          <div class="grid__tracks">
            <div class="--title">
              Track 2 (Fauno East)
            </div>
            <div class="--slot t2" v-for="info in track2" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <slide :key="3">
          <div class="grid__tracks">
            <div class="--title">
              Track 3 (Salon Azul)
            </div>
            <div class="--slot t3" v-for="info in track3" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>
    <div v-else>
      <div class="grid__container">
        <div class="grid__tracks">
          <div class="--title">
            Track 1 (Fauno West)
          </div>
          <div class="--slot t1 clickable" v-for="info in track1" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
        <div class="grid__tracks">
          <div class="--title">
            Track 2 (Fauno East)
          </div>
          <div class="--slot t2 clickable" v-for="info in track2" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
        <div class="grid__tracks">
          <div class="--title">
            Track 3 (Salon Azul)
          </div>
          <div class="--slot t3 clickable" v-for="info in track3" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cards__container">
    <div v-for="(speaker, index) in speakers" :key="index" class="cards__single cerulean" :class="speaker.class">
      <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
      <div v-if="speaker.imgClass" class="circle"></div>
      <div class="cards__speaker">
        <p class="cards__name">{{ speaker.name }}</p>
        <p class="cards__spktitle spkposition" v-html="speaker.position"></p>
        <p class="cards__spktitle" v-html="speaker.title"></p>
      </div>
      <div class="cards__description">
        <p class="time">{{ speaker.time }}</p>
        <p class="location">{{ speaker.location }}</p>
      </div>
    </div>
    <div class="cards__single green">
      <p class="cards__title">
        Happy Hour Brought by Chardan
      </p>
      <div class="cards__description">
        <p>5:00 PM - 7:00 PM</p>
      </div>
      <div class="cards__location">
        @ Tacos & Tequila (Condado Vanderbilt)
      </div>
    </div>
    <div class="cards__single green">
      <p class="cards__title">
        The Money Ball - Old San Juan
      </p>
      <div class="cards__description">
        <p>8:00 PM to 11:00 PM</p>
      </div>
      <div class="cards__location">
        @ <a href="https://maps.app.goo.gl/hw15vz49FBZukN9W9" target="_blank">Bitcoin Center</a>
        <br>257 C. de San Justo, San Juan, 00901, PR
      </div>
    </div>
  </div>
  <div :class="{ 'modal-show': isModalOpen }" v-if="isModalOpen" class="modal" @click="handleModalBackdropClick">
    <div class="modal-content" @click.stop>
      <span class="close" @click="closeModal">&times;</span>
      <div v-if="errorMessage">
        <h1 class="title">Error</h1>
        <p class="description">{{ errorMessage }}</p>
      </div>
      <div v-else>
        <h1 class="speaker">{{ activeCardInfo?.speaker || activeCompanyInfo?.company }}</h1>
        <h2 v-if="activeCardInfo" class="title">{{ activeCardInfo.title }}</h2>
        <p class="description" v-if="activeCardInfo" v-html="activeCardInfo.description"></p>
        <p class="description" v-if="activeCompanyInfo" v-html="activeCompanyInfo.description"></p>
        <a
          v-if="activeCompanyInfo?.url"
          :href="activeCompanyInfo.url"
          target="_blank"
          class="btn-new-alt"
        >
          Visit Website
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
  name: 'Day Two Afternoon',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      track1: [
        { start: '2:00 PM', end: '2:30 PM', company: 'GameSquare Holdings', hr: '14:00', duration: 29 },
        { start: '2:30 PM', end: '3:00 PM', company: 'Zhittya Genesis Medicine', hr: '14:30', duration: 29 },
        { start: '3:00 PM', end: '3:30 PM', company: 'Elauwit Connection, Inc.', hr: '15:00', duration: 29 },
        { start: '3:30 PM', end: '4:00 PM', company: 'Wire Network', hr: '15:30', duration: 29 }
      ],
      track2: [
        { start: '2:00 PM', end: '2:30 PM', company: 'Panel: Investing in Decentralized AI', hr: '14:00', duration: 29 },
        { start: '2:30 PM', end: '3:00 PM', company: 'Taoshi', hr: '14:30', duration: 29 },
        { start: '3:00 PM', end: '3:30 PM', company: 'XSET', hr: '15:00', duration: 29 },
        { start: '3:30 PM', end: '4:00 PM', company: 'GPO Plus', hr: '15:30', duration: 29 }
      ],
      track3: [
        { start: '2:00 PM', end: '2:30 PM', company: 'First Phosphate Corp', hr: '14:00', duration: 29 },
        { start: '2:30 PM', end: '3:00 PM', company: 'Circle Life', hr: '14:30', duration: 29 },
        { start: '3:00 PM', end: '3:30 PM', company: 'Rock Tech Consulting', hr: '15:00', duration: 29 },
        { start: '3:30 PM', end: '4:00 PM', company: 'Canstar Resources Inc.', hr: '15:30', duration: 29 }
      ],
      companyData: {
        'GameSquare Holdings': {
          description: "GameSquare's (NASDAQ: GAME) mission is to revolutionize the way brands and game publishers connect with hard-to-reach Gen Z, Gen Alpha, and Millennial audiences. Our next generation media, entertainment, and technology capabilities drive compelling outcomes for creators and maximize our brand partners' return on investment. Through our purpose-built platform, we provide award winning marketing and creative services, offer leading data and analytics solutions, and amplify awareness through FaZe Clan, one of the most prominent and influential gaming organizations in the world. With one of the largest gaming media networks in North America, as verified by Comscore, we are reshaping the landscape of digital media and immersive entertainment. GameSquare's largest investors are Dallas Cowboys owner Jerry Jones and the Goff family.",
          url: 'https://www.gamesquare.com/'
        },
        'Zhittya Genesis Medicine': {
          description: "Zhittya Genesis Medicine is a biotechnology company developing a biological medicine, FGF-1, to address the cause of death fo 65% of all adults in the world: a lack of blood flow. Over 75 human diseases are caused by a lack of blood flow, such as Heart Disease, Stroke, Chronic Wounds, Type-2 Diabetes, Dementia, and Parkinson's Disease. FGF-1 is a potent angiogenic factor, meaning it is capable of growing new blood vessels and repairing existing blood vessels, while also possessing the ability to regenerate other tissue.",
          url: 'https://www.zgm.care/'
        },
        'Elauwit Connection, Inc.': {
          description: 'Elauwit Connection, Inc. designs, builds, and operates managed broadband internet and property-wide WiFi networks, primarily for multifamily and student housing properties in the U.S., offering fiber-optic infrastructure, high-speed internet, 24/7 support, and network services to property owners, REITs, and management companies to enhance connectivity and resident satisfaction. They provide revenue-generating technology solutions, transforming properties with robust digital infrastructure. ',
          url: 'https://elauwit.com/'
        },
        'Wire Network': {
          description: "Wire Network has made substantial leaps in innovation across many verticals. Wire Network is an L1 Blockchain with APOS (Appointed Proof of Stake) consensus with term limits and network expansion to create a democratic, decentralized consensus layer that scales with user growth.<br><br>Wire Network is the first blockchain to provide network resources to applications for a blockchain backed Web2 experience. Node holder's can utilize resources through contract whitelisting. Users who interact with whitelisted contracts will enjoy free transaction fees. Resources are regenerative and remaining resources will be sent the the resource exchange automatically for additional revenue.",
          url: 'https://www.wire.network/'
        },
        'Taoshi': {
          description: "Taoshi democratizes access to advanced trading strategies and wealth-building tools through its decentralized infrastructure, blockchain transparency, and AI-driven innovation, empowering individuals and institutions to invest with clarity and confidence. We aim to become the world's leading decentralized trading network and premier platform for AI-enhanced trading strategies, driving consistent and risk-managed returns for traders and investors worldwide.",
          url: 'https://www.taoshi.io/'
        },
        'XSET': {
          description: 'XSET is a fast-growing gaming lifestyle and media brand, founded in 2020, that operates esports teams in games like Valorant, Fortnite, and Rocket League, while also building a diverse community through content, apparel, and cultural events, aiming to be a major player at the intersection of gaming, music, and pop culture for the Gen Z audience. The company emphasizes inclusivity, aiming to represent the diversity of gamers through its teams and brand identity, with co-owners and investors like Ozuna, Swae Lee, and quality Control. ',
          url: 'https://xset.com/'
        },
        'GPO Plus': {
          description: 'GPOX is an AI-powered Distributor revolutionizing the future of distribution to gas stations and convenience stores with its innovative technology-driven Direct Store Delivery (DSD) model. Our goal is clear and ambitious: "to build the largest nationwide DSD distribution company servicing gas stations, convenience stores, and beyond." Our technology-driven AI network, featuring strategically placed Regional Hubs and Mini Hubs, is designed to optimize efficiency and maximize reach. Central to our operations is our in-house AI technology platform, PRISM+. Designed to streamline the distribution process, PRISM+ supports efficient delivery, inventory management, data analytics, and overall operational excellence, enabling us to reliably and effectively meet the dynamic needs of our partners. Our mission is to consolidate the fragmented market segment managed by numerous regional vendors. Our dedication to excellence is evident in our product selection process, where we align offerings with consumer demand and partner with top-tier vendors and brands, ensuring our portfolio remains diverse and highly profitable.',
          url: 'https://gpoplus.com/'
        },
        'First Phosphate Corp': {
          description: 'First Phosphate (CSE: PHOS) (OTCQX: FRSPF) (FSE: KD0) is an exploration, mineral development and cleantech company dedicated to building and onshoring a vertically integrated mine-to-market LFP battery supply chain for North America.  Target markets include energy storage, data centers, robotics, mobility and national security.<br><br>First Phosphate’s flagship Bégin-Lamarche Property in Saguenay–Lac-Saint-Jean, Quebec is one of North America’s rare igneous phosphate resources, yielding high-purity phosphate with minimal impurities.',
          url: 'https://firstphosphate.com/'
        },
        'Circadian Group': {
          description: 'Circadian prides itself on working with select companies in the latter stages of early growth working towards a near-term transformational catalyst. Working with exceptional success stories not only bolsters our distinguished track-record, but also reflects favorably on all Circadian clients.<br><br>Unique to the marketplace, Circadian uses a comprehensive and integrated suite of “pull” strategies to showcase a client’s value proposition in an engaging format. Active offense is the only way to win in today’s market.',
          url: 'https://thecircadiangroup.com/'
        },
        'Rock Tech Consulting': {
          description: 'Rock Tech Consulting GmbH is a German-based company whose corporate purpose is the planning, development, construction, and operation of lithium processing plants. It is a subsidiary of the cleantech company Rock Tech Lithium Inc., which is focused on creating a localized, sustainable supply chain for lithium in North America and Europe to support the electric vehicle (EV) battery market. ',
          url: 'https://rocktechlithium.com/'
        },
        'Canstar Resources Inc.': {
          description: 'Canstar Resources Inc. is a Canadian junior mineral exploration company, headquartered in Toronto, focused on acquiring and developing gold and critical mineral (zinc, silver, copper, antimony) properties in Newfoundland, Canada, with key assets being the district-scale Golden Baie Project and the Buchans-Mary March project in the historic Buchans Mining Camp, utilizing advanced exploration to unlock potential for significant discoveries. ',
          url: 'https://www.canstarresources.com/'
        },
        'Circle Life': {
          description: 'AI-driven peptide-first platform unlocking full human potential',
          url: 'https://circlelife.health/'
        },
      },
      speakers: [
        {
          imgClass: 'pojunis',
          name: 'Brett H. Pojunis',
          position: 'Chairman of the Board & CEO - GPO Plus, Inc.',
          time: '3:30 PM - 4:00 PM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'pierce',
          name: 'Brock Pierce',
          position: 'Co-Founder - DNA',
          time: '4:00 PM - 4:45 PM',
          location: 'Patio del Fauno'
        },
        {
          name: 'Chardan',
          title: 'Company Presentation',
          time: '4:45 PM - 5:00 PM',
          location: 'Patio del Fauno',
          class: 'grayblue presenter noheight'
        },
      ],
      cardData: {
      },
      activeCardInfo: null,
      isModalOpen: false,
      isMobile: false,
      errorMessage: null,
      eventDay: 2
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleEscKey);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.isModalOpen) {
        this.closeModal();
      }
    },
    handleModalBackdropClick(event) {
      // Close modal when clicking on the backdrop (not the content)
      if (event.target.classList.contains('modal')) {
        this.closeModal();
      }
    },
    openModal(identifier) {
      if (this.cardData[identifier]) {
        this.activeCardInfo = this.cardData[identifier];
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else if (this.companyData[identifier]) {
        this.activeCompanyInfo = {
          ...this.companyData[identifier],
          company: identifier,
        };
        this.activeCardInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else {
        console.error(`Currently no info has been found for "${identifier}".`);
        this.activeCardInfo = null;
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = false;
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.activeCardInfo = null;
      this.activeCompanyInfo = null;
      this.errorMessage = null;
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>